module.exports = __webpack_public_path__ + "img/index-section6-friend6.fbef7ddd.svg";